import { Injectable } from '@angular/core';
import { Store }      from '@ngrx/store';
import {
  assignDocument,
  clearAssignDocument,
  reloadPage,
}                     from '../../state/app.actions';
import {
  selectAssignDocumentClients,
  selectAssignDocumentIsLoading,
  selectAssignDocumentType,
  selectAssignDocumentUrl,
}                     from '../../state/app.selectors';

@Injectable({
  providedIn: 'root',
})
export class AssignDocumentService {
  assignDocumentType$ = this.store.select(selectAssignDocumentType);
  assignDocumentUrl$ = this.store.select(selectAssignDocumentUrl);
  assignDocumentClients$ = this.store.select(selectAssignDocumentClients);
  assignDocumentIsLoading$ = this.store.select(selectAssignDocumentIsLoading);

  constructor(private readonly store: Store) {
  }

  assignDocuments(documentIds: string[], clientId: string) {
    this.store.dispatch(assignDocument({ documentIds, clientId }));
  }

  clearAssignDocument() {
    this.store.dispatch(clearAssignDocument());
  }

  reloadPage() {
    this.store.dispatch(reloadPage());
  }
}
